import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useAsyncFn } from 'react-use';

import { client } from './app/api/useClient';
import { LoadingOverlay } from './app/components';
import { AppRoutes } from './app/router';

export function App() {
  const {
    isLoading,
    isAuthenticated,
    getAccessTokenSilently,
    loginWithRedirect,
  } = useAuth0();

  // Auth0 gets into existinal crisis (infinity redirects) if you manually remove the token from local storage
  // so we need to wait for Auth0 to finish authenticating before we try to authenticate again (hence a redirect)
  // const [{ loading: isAuthenticating }, authenticate] = useAsyncFn(
  //   loginWithRedirect,
  //   [loginWithRedirect],
  // );

  const [{ loading: isFetchingToken, value: token }, getToken] = useAsyncFn(
    getAccessTokenSilently,
    [getAccessTokenSilently],
  );

  useEffect(() => {
    // isLoading is an indicator whether Auth0 is still loading the user's authentication state
    // isAuthenticated is an indicator whether the user is authenticated
    // isAuthenticating is an indicator whether the user is currently being authenticated
    // if the user is authenticated or is currently being authenticated, we don't need to do anything

    if (isLoading || isAuthenticated) {
      return;
    }

    if (!isAuthenticated) {
      loginWithRedirect();
    }
  }, [isAuthenticated, isLoading, loginWithRedirect]);

  useEffect(() => {
    if (isLoading || isFetchingToken) {
      return;
    }
    if (token) {
      if (typeof token === 'string') {
        // store in localstorage to send it using fetch fn in baseUrl too
        client.setOptions({ token: token });
      }
      return;
    }
    getToken();
  }, [isFetchingToken, isAuthenticated, getToken, token, isLoading]);

  if (isLoading) {
    return <LoadingOverlay />;
  }

  return <AppRoutes />;
}

export default App;
